module.exports = __webpack_public_path__ + "static/media/clear-time-period_active.5211162f.svg";